import createPersistedState from 'vuex-persistedstate'
import cookie from 'cookie'
export default ({ store, req, app }) => {
  createPersistedState(
    {
      key: 'YDS_STORE_VALUE',
      paths: ['user.auth'],
      storage: {
        getItem: key => (process.server && req !== undefined && req.headers.cookie !== null) ? cookie.parse(req.headers.cookie || '')[key] : app.$cookiz.get(key),
        setItem: (key, value) => app.$cookiz.set(key, value, {
          maxAge: 30 * 24 * 60 * 60, // 30 days in seconds
          path: '/'
        }),
        removeItem: key => app.$cookiz.remove(key)
      }
    }
  )(store)
  createPersistedState(
    {
      key: 'YDS_DOCTOR_VALUE',
      paths: ['doctor.doctorData.Doctor'],
      storage: {
        getItem: key => (process.server && req !== undefined && req.headers.cookie !== null) ? cookie.parse(req.headers.cookie || '')[key] : app.$cookiz.get(key),
        setItem: (key, value) => app.$cookiz.set(key, value, {
          maxAge: 30 * 24 * 60 * 60, // 30 days in seconds
          path: '/'
        }),
        removeItem: key => app.$cookiz.remove(key)
      }
    }
  )(store)
  createPersistedState(
    {
      key: 'YDS_BOOKING_VALUE',
      paths: ['doctor.booking'],
      storage: {
        getItem: key => (process.server && req !== undefined && req.headers.cookie !== null) ? cookie.parse(req.headers.cookie || '')[key] : app.$cookiz.get(key),
        setItem: (key, value) => app.$cookiz.set(key, value, {
          maxAge: 30 * 24 * 60 * 60, // 30 days in seconds
          path: '/'
        }),
        removeItem: key => app.$cookiz.remove(key)
      }
    }
  )(store)
}
